import { render, staticRenderFns } from "./ClientsMailsDeliveredPage.vue?vue&type=template&id=b167e772"
import script from "./ClientsMailsDeliveredPage.vue?vue&type=script&lang=js"
export * from "./ClientsMailsDeliveredPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports